import React from 'react';
import { WebUiButton } from 'src/modules/web-ui/components/button';

import { humanByteSize } from './c-system-settings-utils';

type FileEntry = { name: string; size: number };

type Props = {
  list: FileEntry[];
  webexport?: boolean;
  admin: boolean;
  onApply: (name: string) => void;
  onDownload: (name: string) => void;
  onDelete: (name: string) => void;
};

export default function CSystemFilesListTable({
  list,
  webexport,
  admin,
  onApply,
  onDownload,
  onDelete,
}: Props) {
  return (
    <table className="webui-table w-full">
      <thead>
        <tr className="webui-table-row-head">
          <th>Name</th>
          <th>Size</th>
          <th>URL</th>
          <th>Operation</th>
        </tr>
      </thead>
      <tbody>
        {list.map((file) => {
          const isTar = file.name === 'files.tar';
          const url = webexport
            ? `${window.location.origin}/files/${file.name}`
            : 'N/A';
          const canEdit = admin && !isTar;
          return (
            <tr key={file.name} className="webui-table-row-content">
              <td className="text-left">{file.name}</td>
              <td className="text-right">{humanByteSize(file.size)}</td>
              <td className={webexport ? 'break-all text-left' : 'text-center'}>
                {url}
              </td>
              <td className="text-center">
                <div className="flex flex-row gap-1">
                  <WebUiButton
                    disabled={!canEdit}
                    onClick={() => onApply(file.name)}
                  >
                    Apply
                  </WebUiButton>
                  <WebUiButton
                    disabled={!admin}
                    onClick={() => onDownload(file.name)}
                  >
                    Download
                  </WebUiButton>
                  <WebUiButton
                    disabled={!canEdit}
                    onClick={() => onDelete(file.name)}
                  >
                    Delete
                  </WebUiButton>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
